import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Box } from '@sternum/styled-system';
import { Button, Link, Text12M, Text12SB } from '@sternum/ui';
import { Separator, SternumLogo, Text } from '@sternum/web/components';
import { Colors } from '@sternum/web/components/theme/constants';
import { ThemeProvider } from '@sternum/web/components/theme/main';
import { Config } from '@sternum/web/config';
import { routes } from '@sternum/web/config/routes';
import { namespaces } from '@sternum/web/services/i18n';

import { Container } from './MarketingBlock.styles';

export function MarketingBlockForSandbox() {
  const { t } = useTranslation(namespaces.appContainerWithMenu);
  const navigate = useNavigate();

  return (
    <Container aria-label="marketing block sandbox">
      <Box textAlign="center">
        <SternumLogo textColor={Colors.White} />
      </Box>

      <Box textAlign="center">
        <Box>
          <Text12M color={Colors.GreyLighter}>{t('marketingBlock.upgradeLicenceAndContactUs')}</Text12M>
        </Box>
        <Box>
          <Link href={`mailto:${Config.app.serviceEmail}`} color={Colors.GreyLightest}>
            <Text12SB color={Colors.GreyLightest}>{Config.app.serviceEmail}</Text12SB>
          </Link>
        </Box>
      </Box>

      <Box py={6} px={10}>
        <Separator
          color={{
            Dark: 'DarkerMiddle',
            Light: 'DarkerMiddle',
          }}
          label={
            <Text size={10} weight={500} color={{ Light: 'Dark', Dark: 'Dark' }}>
              {t('marketingBlock.or')}
            </Text>
          }
          labelBg={{
            Dark: 'DarkestMiddle',
            Light: 'DarkestMiddle',
          }}
        />
      </Box>

      <ThemeProvider mode="Light">
        <Button
          variant="primary"
          onClick={() => {
            navigate({
              pathname: routes.auth.registrationDevices.absolute,
            });
          }}
        >
          {t('marketingBlock.startTrialButtonLabel')}
        </Button>
      </ThemeProvider>
    </Container>
  );
}
